<template>
  <div class="card inventory-lookup">
    <div class="card__header">
      <h2>Inventory Lookup</h2>
    </div>
    <div class="card__body">
      <el-row :gutter="24" class="search-row" style="margin-bottom: 20px;">
        <!-- Search Input -->
        <el-col :xs="24" :sm="12" :md="5" :lg="5">
          <el-input
              placeholder="Search Style-Color here"
              v-model="searchQuery"
              prefix-icon="el-icon-search"
              clearable
              style="width: 100%;"
          />
        </el-col>

        <!-- Site Selection -->
        <el-col :xs="24" :sm="12" :md="5" :lg="5">
          <el-select
              v-model="d365Entity"
              placeholder="Select Site"
              clearable
              style="width: 100%;"
          >
            <el-option
                v-for="item in sites"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-col>
        <!-- Fulfillment Location Selection -->
        <el-col :xs="24" :sm="12" :md="5" :lg="5">
          <el-select
              v-model="fulfillmentLocation"
              placeholder="Select Fulfillment Location"
              clearable
              style="width: 100%;"
          >
            <el-option
                v-for="item in fulfillmentLocations"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-col>

        <!-- Action Buttons (Search, Sync, Upload, Config) -->
        <el-col :xs="24" :sm="24" :md="9" :lg="9" class="action-buttons">
          <el-row :gutter="10">
            <!-- Search Button -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6">
              <el-button
                  type="success"
                  icon="el-icon-search"
                  @click="search()"
                  :disabled="loading"
                  style="width: 100%; white-space: nowrap; padding: 12px;"
              >
                Search
              </el-button>
            </el-col>

            <!-- Sync Button -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6">
              <el-button
                  type="primary"
                  icon="el-icon-refresh"
                  @click="sync()"
                  :disabled="loading || !result.length"
                  style="width: 100%; white-space: nowrap; padding: 12px;"
              >
                Sync
              </el-button>
            </el-col>

            <!-- CSV Upload Button -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6">
              <el-button
                  type="success"
                  icon="el-icon-upload"
                  @click="showUploadDialog = true"
                  :disabled="loading"
                  style="width: 100%; white-space: nowrap; padding: 12px;"
              >
                Sync with CSV
              </el-button>
            </el-col>

            <!-- Config Button -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6">
              <el-button
                  type="warning"
                  icon="el-icon-setting"
                  @click="openThreshold"
                  :loading="loading"
                  style="width: 100%; white-space: nowrap; padding: 12px;"
              >
                Config
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-table v-loading="loading" :data="result">
            <el-table-column prop="sku" label="SKU"/>
            <el-table-column prop="size" label="Size"/>
            <el-table-column align="center" prop="quantity" label="Qty"/>
            <el-table-column align="center" prop="in_transit" label="In Transit"/>
            <el-table-column align="center" prop="shopify_quantity" label="Shopify Qty"/>
            <el-table-column align="center" label="Difference">
              <template slot-scope="scope">
                <span v-if="variants[scope.row.sku].difference === 0">0</span>
                <div class="bg-info text-danger"
                     v-else-if="variants[scope.row.sku].difference >= scope.row.sell_minimum_threshold">
                  {{ variants[scope.row.sku].difference }}
                </div>
                <span v-else>{{ variants[scope.row.sku].difference }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="fbm_quantity" label="FBM Qty"/>
            <el-table-column align="center" prop="price" label="Price"/>
            <el-table-column align="center" label="Sync">
              <template slot-scope="scope">
                <input type="checkbox" v-model="variants[scope.row.sku].sync_inventory"
                       label="Sync Inventory" @change="changeSync"/>
              </template>
            </el-table-column>
            <el-table-column align="center" label="Shopify Threshold">
              <template slot-scope="scope">
                <input type="number" placeholder="Sync Threshold" :disabled="loading"
                       v-model="variants[scope.row.sku].threshold_quantity" @change="changeSync"/>
              </template>
            </el-table-column>
            <el-table-column align="center" label="FOS">
              <template slot-scope="scope">
                <input type="checkbox" v-model="variants[scope.row.sku].force_out_of_stock"
                       label="Sync Inventory" @change="changeSync"/>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="showUploadDialog" width="30%">
      <template slot="title">
        <h4>Upload a CSV</h4>
      </template>
      <div>
        <span>
          <el-upload
              action=""
              :multiple="false"
              :limit="2"
              :on-change="handleUploadChange"
              :auto-upload="false"
              accept=".csv"
              :file-list="fileList">
            <el-button size="small" type="primary">Select File</el-button>
            <div slot="tip" class="el-upload__tip">CSV files only please</div>
          </el-upload>
        </span>
        <br>
        <span>
          <el-select v-model="uploadToRegion"
                     placeholder="Select a Store">
            <el-option
                v-for="item in sites"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" :disabled="!this.fileList.length || !this.uploadToRegion" type="primary"
                   @click="uploadFile">Submit</el-button>
        <el-button type="primary" @click="showUploadDialog = false">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showSyncThresholdDialog" width="50%" :close-on-click-modal="false">
      <template slot="title">
        <h3 style="font-weight: bold; margin-bottom: 0;">Sync Configuration & Flag Management</h3>
      </template>

      <div class="dialog-content" style="padding: 20px;">

        <!-- Sync Configuration Section -->
        <h4 style="font-weight: bold; margin-bottom: 10px;">Sync Configuration</h4>

        <!-- Shopify Sync Threshold -->
        <div class="form-item" style="margin-bottom: 20px;">
          <label style="display: block; font-weight: bold; margin-bottom: 5px;">Shopify Sync Threshold:</label>
          <el-input-number
              v-model="shopifyThreshold"
              :min="1"
              :max="10000"
              placeholder="Set Shopify Sync Threshold"
              style="width: 100%;">
          </el-input-number>
        </div>

        <!-- Shopify Bundle Sync Threshold -->
        <div class="form-item" style="margin-bottom: 20px;">
          <label style="display: block; font-weight: bold; margin-bottom: 5px;">Shopify Bundle Sync Threshold:</label>
          <el-input-number
              v-model="shopifyBundleThreshold"
              :min="1"
              :max="10000"
              placeholder="Set Shopify Bundle Sync Threshold"
              style="width: 100%;">
          </el-input-number>
        </div>

        <!-- Amazon Sync Threshold -->
        <div class="form-item" style="margin-bottom: 20px;">
          <label style="display: block; font-weight: bold; margin-bottom: 5px;">Amazon Sync Threshold:</label>
          <el-input-number
              v-model="amazonThreshold"
              :min="1"
              :max="10000"
              placeholder="Set Amazon Sync Threshold"
              style="width: 100%;">
          </el-input-number>
        </div>

        <!-- Flag Management Section -->
        <h4 style="font-weight: bold; margin: 30px 0 10px;">Force Out of Stock Flag Management</h4>

        <!-- Export All Flagged SKUs -->
        <div class="form-item" style="margin-bottom: 20px;">
          <el-button type="primary" @click="exportFlaggedSkus" style="width: 100%;">
            <i class="el-icon-download"></i> Export All Force Out of Stock SKUs
          </el-button>
        </div>

        <!-- Upload CSV for Mass Removal -->
        <div class="form-item" style="margin-bottom: 20px;">
          <label style="font-weight: bold; display: block; margin-bottom: 5px;">Mass Remove Flagged SKUs (Upload
            CSV)</label>
          <el-upload
              action=""
              :multiple="false"
              :on-change="handleUploadChange"
              :auto-upload="false"
              accept=".csv"
              :file-list="fileList"
              class="upload-block">
            <el-button size="medium" type="primary" style="width: 100%;">
              <i class="el-icon-upload"></i> Select CSV File
            </el-button>
            <div slot="tip" class="el-upload__tip">Upload a CSV file to mass remove flags from SKUs</div>
          </el-upload>
        </div>

        <!-- Set Frequency for Automatic Flag Removal -->
        <div class="form-item" style="margin-bottom: 20px;">
          <label style="display: block; font-weight: bold; margin-bottom: 5px;">Set Frequency for Auto Flag Removal
            (Days):</label>
          <el-input-number
              v-model="autoRemoveFrequency"
              :min="1"
              :max="365"
              placeholder="Set Auto Removal Frequency"
              style="width: 100%;">
          </el-input-number>
        </div>
      </div>

      <!-- Footer with Buttons -->
      <span slot="footer" class="dialog-footer" style="text-align: right;">
    <el-button type="primary" @click="updateSyncThreshold" :loading="loading" style="margin-right: 10px;">
      Update Configuration
    </el-button>
    <el-button @click="showSyncThresholdDialog = false">Cancel</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import axios, {RepositoryError} from '../../repositories';
import notify from '../../mixins/notify';

export default {
  data() {
    return {
      showUploadDialog: false,
      showSyncThresholdDialog: false,
      fileList: [],
      uploadToRegion: '',
      shopifyThreshold: '',
      shopifyBundleThreshold: '',
      amazonThreshold: '',
      autoRemoveFrequency: '',
      sites: [
        {
          value: 'usa',
          label: 'USA',
        }, {
          value: 'ca',
          label: 'Canada',
        },
      ],
      searchQuery: '',
      d365Entity: '',
      result: [],
      variants: {},
      loading: false,
      fulfillmentLocations: [
        {
          value: 'NLS',
          label: 'NLS',
        }, {
          value: 'JAS',
          label: 'JAS',
        },
      ],
      fulfillmentLocation: '',
    };
  },
  async created() {
    const {variantId, region, locationId} = this.$route.query;
    this.d365Entity = region || '';

    if (!variantId && !locationId) {
      return;
    }

    try {
      const {data} = await axios.get('/inventory/prefill', {
        params: {variantId, region, locationId},
      });

      this.searchQuery = data.styleColor || '';
      this.d365Entity = data.region || this.d365Entity;
      this.fulfillmentLocation = data.fulfillmentLocation || '';

      if (this.searchQuery && this.d365Entity && this.fulfillmentLocation) {
        await this.search();
      }
    } catch (err) {
      if (!(err instanceof RepositoryError)) {
        throw err;
      }
    }
  },
  methods: {
    handleUploadChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    exportFlaggedSkus() {
      this.loading = true;

      // Make an API request to the Laravel backend to get the CSV data
      axios({
        url: '/inventory/export-fos-skus', // Laravel route
        method: 'GET',
        responseType: 'blob', // Important to handle binary data
      }).then((response) => {
        // Create a new Blob from the response
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = url;

        // Set the file name for download
        link.setAttribute('download', 'flagged_skus.csv');

        // Append the anchor to the body
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link after triggering the download
        document.body.removeChild(link);

        // Free up the memory by revoking the object URL
        window.URL.revokeObjectURL(url);

        this.$message.success('Flagged SKUs exported successfully');
      }).catch((error) => {
        console.error('Error exporting flagged SKUs:', error);
        this.$message.error('Failed to export flagged SKUs');
      }).finally(() => {
        this.loading = false;
      });
    },
    async uploadFile() {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.fileList[0].raw);
        formData.append('region', this.uploadToRegion);
        const response = await axios.post('/inventory/upload', formData,
            {headers: {'Content-Type': 'multipart/form-data'}});
        this.notify('Successfully uploaded, syncing in progress.', 'success');
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async openThreshold() {
      this.loading = true;
      this.fileList = [];
      try {
        const response = await axios.get('/inventory/get-threshold');
        if (response.data) {
          this.shopifyThreshold = response.data.shopifyThreshold;
          this.shopifyBundleThreshold = response.data.shopifyBundleThreshold;
          this.amazonThreshold = response.data.amazonThreshold;
          this.autoRemoveFrequency = response.data.autoRemoveFrequency;
          this.showSyncThresholdDialog = true;
        } else {
          this.notify('No threshold data received from server.', 'warning');
        }
      } catch (err) {
        if (err instanceof RepositoryError) {
          this.notify('A repository error occurred while fetching thresholds.', 'danger');
          return;
        }
        if (err.response && err.response.data && err.response.data.message) {
          this.notify(`Error: ${err.response.data.message}`, 'danger');
        } else {
          this.notify('An unexpected error occurred while fetching thresholds.', 'danger');
        }
        console.error('Threshold fetch error:', err);
      } finally {
        this.loading = false;
      }
    },
    async updateSyncThreshold() {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('shopifyThreshold', this.shopifyThreshold);
        formData.append('shopifyBundleThreshold', this.shopifyBundleThreshold);
        formData.append('amazonThreshold', this.amazonThreshold);
        formData.append('autoRemoveFrequency', this.autoRemoveFrequency);
        if (this.fileList.length > 0 && this.fileList[0].raw) {
          formData.append('file', this.fileList[0].raw);
        }
        const response = await axios.post('/inventory/update-threshold', formData,
            {headers: {'Content-Type': 'multipart/form-data'}});
        this.notify('Sync threshold successfully updated', 'success');
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    /**
     * Updates inventory sync settings for variants.
     *
     * Sends a POST request to `/d365/inventory` with the current `variants` object,
     * along with the selected region and search query as parameters.
     * On success, updates the `result` and `variants` data with the response.
     * Handles loading state and errors, including repository errors.
     *
     * @async
     * @returns {Promise<void>}
     */
    async changeSync() {
      if (this.d365Entity.trim() === '') {
        this.notify(
            'Please select a region from the drop down list',
            'danger',
        );
        return;
      }

      if (this.fulfillmentLocation.trim() === '') {
        this.notify(
            'Please select a fulfillment location from the drop down list',
            'danger',
        );
        return;
      }

      this.loading = true;
      try {
        let response = await axios.post('/d365/inventory', this.variants, {
          params: {
            region: this.d365Entity,
            sku: this.searchQuery,
            fulfillment_location: this.fulfillmentLocation,
          },
        });

        if (response.data) {
          this.result = response.data.variants;
          response.data.variants.forEach((v) => {
            this.variants[v.sku] = {
              sync_inventory: v.sync_inventory,
              threshold_quantity: v.threshold_quantity,
              force_out_of_stock: v.force_out_of_stock,
              published: v.published,
            };
          });
        }
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    /**
     * Searches for inventory data based on the current search query and selected region.
     *
     * - Validates the search query and region selection.
     * - Sends a GET request to `/d365/inventory` with the search parameters.
     * - Populates `result` and `variants` with the response data if available.
     * - Notifies the user if no data is found or if an error occurs.
     *
     * @async
     * @returns {Promise<void>}
     */
    async search() {
      if (this.searchQuery.trim() === '' ||
          !this.searchQuery.trim().match(/^.+[-].+$/)) {
        this.notify(
            'Please enter a Style-Color in the search field',
            'danger',
        );
        return;
      }

      if (this.d365Entity.trim() === '') {
        this.notify(
            'Please select a region from the drop down list',
            'danger',
        );
        return;
      }

      if (this.fulfillmentLocation.trim() === '') {
        this.notify(
            'Please select a fulfillment location from the drop down list',
            'danger',
        );
        return;
      }

      this.loading = true;
      this.result = [];

      try {
        const response = await axios.get('/d365/inventory', {
          params: {
            region: this.d365Entity,
            sku: this.searchQuery,
            fulfillment_location: this.fulfillmentLocation,
          },
        });

        if (response.data && Array.isArray(response.data.variants)) {
          this.result = response.data.variants;
          response.data.variants.forEach((v) => {
            this.variants[v.sku] = {
              difference: v.quantity - v.in_transit - v.shopify_quantity,
              sync_inventory: v.sync_inventory,
              threshold_quantity: v.threshold_quantity,
              force_out_of_stock: v.force_out_of_stock,
              published: v.published,
            };
          });
        } else {
          this.notify('No inventory data found for the given Style-Color and region.', 'warning');
        }
      } catch (err) {
        if (err instanceof RepositoryError) {
          // Optionally show a specific message for repository errors
          this.notify('A repository error occurred while searching inventory.', 'danger');
          return;
        }
        if (err.response && err.response.data && err.response.data.message) {
          this.notify(`Error: ${err.response.data.message}`, 'danger');
        } else {
          this.notify('An unexpected error occurred while searching inventory.', 'danger');
        }
        console.error('Inventory search error:', err);
      } finally {
        this.loading = false;
      }
    },
    async sync() {
      if (this.searchQuery.trim() === '' ||
          !this.searchQuery.trim().match(/^.+[-].+$/)) {

        return this.notify(
            'Please enter a Style-Color in the search field',
            'danger',
        );
      }

      if (this.d365Entity.trim() === '') {
        return this.notify(
            'Please select a D365 region from the drop down list',
            'danger',
        );
      }

      this.loading = true;

      try {
        await axios.get('/inventory/sync', {
          params: {
            region: this.d365Entity,
            sku: this.searchQuery,
          },
        });

        return this.notify('Syncing product in progress.', 'success');
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
  mixins: [notify],
};
</script>
